import colors from 'app/colors'
import Svg from 'app/features/component/svg'
import useCommonResponsiveValues from 'app/hooks/useCommonResponsiveValues'
import { Box, VStack, Text, useBreakpointValue, Stack } from 'native-base'
import { type Ref } from 'react'

type Props = {
	heroRef: Ref<HTMLDivElement>
}

const IntroSection1 = ({ heroRef }: Props) => {
	const { containerWidth } = useCommonResponsiveValues()
	const textSizeProp = useBreakpointValue({
		base: {
			size: 'h6/600',
		},
		lg: {
			fontSize: '36px',
			fontWeight: 600,
			lineHeight: '60px',
		},
	})

	const imgSrc = useBreakpointValue({
		base: {
			asset: require('app/assets/main/1on1_mobile_img_sub_01.svg'),
			src: '/main/1on1_mobile_img_sub_01.svg',
		},
		lg: {
			asset: require('app/assets/main/1on1_pc_img_sub_01.svg'),
			src: '/main/1on1_pc_img_sub_01.svg',
		},
	})

	return (
		<Box bgColor="singletons.black" alignItems="center">
			<VStack
				ref={heroRef}
				w={'100%'}
				py={{ base: '72px', lg: '120px' }}
				justifyContent="center"
				alignItems="center"
			>
				<Box h={'58px'} />
				<Text
					size={useBreakpointValue({
						base: 'h3/800',
						lg: 'h2/900/main',
					})}
					textAlign="center"
					color={colors.white50}
				>
					1:1 공부 컨설팅
				</Text>
				<Text
					mt="24px"
					{...textSizeProp}
					textAlign="center"
					color="singletons.white"
				>
					대치동 아이들이 받는 {containerWidth.endsWith('%') && '\n'}
					공부 컨설팅 그대로!{'\n'}
					종합학습진단 결과에 따라 검증된{' '}
					{containerWidth.endsWith('%') && '\n'}
					공부 컨설턴트가 아이를 구체적으로{'\n'}
					분석하여 목표대학을 향해{' '}
					{containerWidth.endsWith('%') && '\n'}공부할 수 있도록
					컨설팅을 해드립니다.{'\n'}
				</Text>
				<Stack
					mt={{ base: '0px', lg: '68px' }}
					height={{ base: '300px', lg: '250px' }}
					alignItems="center"
					zIndex={10}
				>
					<Svg
						width={{ base: '375px', lg: '920px' }}
						height={{ base: '350px', lg: '350px' }}
						src={imgSrc.src}
						asset={imgSrc.asset}
					/>
				</Stack>
				<Stack
					zIndex={1}
					position="absolute"
					top={{ base: '580px', lg: '630px' }}
					width={{ base: '400px', lg: '936px' }}
					height={{ base: '400px', lg: '936px' }}
					borderRadius={{ base: '200px', lg: '468px' }}
					bgColor={colors.green500}
				/>
			</VStack>
		</Box>
	)
}

export default IntroSection1
